import { GeoDataInfo } from './geo-data-info';
import { CalculatePathResponseType } from '../services';
import { LocalizedString, UnitDisplayLedSettings } from '@cue/api';
import {
  Area,
  AreaMetric,
  GroupedInstructionItem,
  NavDirectionItem,
  NavigationReferencePoint,
  PortalDetail,
  StartTargetBasicData,
} from '@cue/data';

export interface QRInfo {
  code: number;
  name: string;
  areaId: number;
  geometry: string;
}

export interface FindPathResponse {
  targetGUID: string;
  startCode: number;
  targetName: string;
  qrCodes: QRInfo[];
  start: GeoDataInfo;
  targets: GeoDataInfo[];
  paths: GeoDataInfo[];
  portals: PortalDetail[];
  areaMetrics: AreaMetric[];
  targetIsResource: boolean;
}

//TODO:Jakub

export interface NavigationDataCrate {
  directions: NavDirectionItem[];
  response: FindPathResponseV2;
  responseType: CalculatePathResponseType;
}

export interface PathResultCrate {
  path: PathInfoResultEnum;
  start: StartTargetResultEnum;
  target: StartTargetResultEnum;
}

export enum PathInfoResultEnum {
  PathFound = 0,
  PathNotFound = 1,
  SameStartAsTarget = 2,
  FoundOnlyNotBarrierPath = 3,
  TempUnknownState = 4,
}

export enum StartTargetResultEnum {
  Found = 0,
  NotFound = 1,
  NotRequested = 2,
}

export interface FindPathResponseV2 {
  areasInfo: AreaMetricV2[];
  path: PathItem[];
  pathInstructions: GroupedInstructionItem[];
  pathResult: PathResultCrate;
  targetIsResource: boolean;
  targetGUID: string;
  targetResourceId: number;
  targetName: string;
  start: StartTargetBasicData;
  target: StartTargetBasicData;
  barrierFree: boolean;
  routeId?: string;
}

export interface IBreadcrumbWithId {
  areaId: number;
  name: LocalizedString;
  item2: any;
}

export interface IAreaMetricsInfoConfig {
  areaId: number;
  name: LocalizedString;
  floorplan: LocalizedString;
  disableRotation?: boolean;
  breadcrumb: LocalizedString[];
  breadcrumbWithIds: IBreadcrumbWithId[];
  zoomLevelMin: number;
  zoomLevelMax: number;
  zoomLevelDefault: number;
  poiFocus: number;
  newFloorplanHeight: number;
  newFloorplanWidth: number;
  referencePoints: NavigationReferencePoint[];
}

export interface DigitalSignageMedia {
  showTime: number;
  type: 'video' | 'image';
  url: string;
  preferCover: boolean;
}

export interface DigitalSignageConfig {
  customText: LocalizedString;
  media: DigitalSignageMedia[];
  showDigitalSignage: boolean;
  showAfterInactivity: number;
  backgroundColor: string;
  backgroundImage: string;
  backgroundId: BackgroundTypeEnum;
}

export enum BackgroundTypeEnum {
  None,
  Navigation,
  Color,
  Image,
}

export type NavigationConfigurationQueryParameters = {
  deploymentId?: string;
  kioskId?: string;
  startQrCodeId?: string;
  startResourceId?: number;
  targetQrCodeId?: string;
  targetResourceId?: number;
  openedResourceId?: number;
  openedQrCodeId?: string;
  areaId?: number;
  wantOnlyBarrierFreePaths?: boolean;
  groupIdx?: number;
};

export interface NavigationConfiguration {
  enable: boolean;
  resetAfterCountdownShow: number;
  showCountdown: number;
  isKiosk: boolean;
  kioskId?: string;
  qrCodeId: string;
  name: string;
  defaultAreaId: number;
  areasInfo: IAreaMetricsInfoConfig[];
  areasInfoData: Area[];
  textForScanQrCode: LocalizedString;
  digitalSignageConfig?: DigitalSignageConfig;
  validFloorplanApp: boolean;
  canNavigateToQRCode: boolean;
  isCachedData: boolean;
  outOfOrder: boolean;
  outOfOrderText: string;
  showVirtualKeyboard: boolean;
}

export enum FloorplanLayoutEnum {
  Navigation = 1,
  Reservation = 2,
  MonitorControl = 3,
}

export interface FloorplanConfiguration extends NavigationConfiguration {
  showYouAreHerePoint: boolean;
  cueSolutionValidLicence: boolean;
  layout: FloorplanLayoutEnum;
  unitDisplayAndLEDSetting: UnitDisplayLedSettings;
}

export interface AreaMetricV2 {
  areaId: number;
  floorplan: string;
  name: LocalizedString;
  ratio: number;
  disableRotation?: boolean;
  breadcrumb: LocalizedString[];
}

export interface PathItem {
  angleDirection: number;
  areaId: number;
  distanceToParent: number;
  isPortal: boolean;
  position: number;
  x: number;
  y: number;
  categoryName?: LocalizedString;
  categoryIcon?: string;
  mapName?: LocalizedString;
  hideInNavigation?: boolean;
  zoomPOI: boolean;
  poiSize: number;
}

export interface ExchangeCodeResponse {
  guid: string;
  areaId: number;
}

export interface ExchangeNavigationCodeResponse {
  guid: string;
  areaId: number;
  resourceId: number;
  redirectToResource: boolean;
}
